import LogoHeader from "../../components/LogoHeader";
import { Footer } from "../../components/Footer";
import { MainContainer, FooterWrapper } from "./styles";
import { useSmartRetailStatus } from "./hooks/useSmartRetailStatus";
import StatusContent from "./components/StatusContent";

const SMART_RETAIL_STATUS = () => {
  const { t, isFadeLoading, dispenseStatusMessage } = useSmartRetailStatus();

  return (
    <MainContainer>
      <LogoHeader enableLanguage={true} />

      <StatusContent
        t={t}
        isFadeLoading={isFadeLoading}
        dispenseStatusMessage={dispenseStatusMessage}
      />

      <FooterWrapper>
        <Footer />
      </FooterWrapper>
    </MainContainer>
  );
};

export default SMART_RETAIL_STATUS;
